function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 59,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.354 42.628c-1.315 0-2.378 1.104-2.378 2.462 0 1.361 1.063 2.462 2.378 2.462 1.313 0 2.379-1.1 2.379-2.462 0-1.358-1.067-2.462-2.379-2.462z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M56.706 30.316c0 15.64-12.246 28.316-27.353 28.316C14.245 58.632 2 45.955 2 30.316 2 14.676 14.245 2 29.353 2 44.46 2 56.706 14.677 56.706 30.316z",
    stroke: props.color,
    strokeWidth: 3.437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M29.577 16.71v19.769",
    stroke: props.color,
    strokeWidth: 3.819,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgWarningCircle;